import * as React from 'react';

const CheckmarkDoneFilledIcon = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}>
      <path
        d="M12.1547 3.35431C12.4476 3.64721 12.4476 4.12208 12.1547 4.41498L7.90468 8.66498C7.61178 8.95787 7.13691 8.95787 6.84401 8.66498C6.55112 8.37208 6.55112 7.89721 6.84401 7.60431L11.094 3.35431C11.3869 3.06142 11.8618 3.06142 12.1547 3.35431Z"
        fill="currentColor"
      />
      <path
        d="M15.0607 3.35431C15.3536 3.64721 15.3536 4.12208 15.0607 4.41498L7.56066 11.915C7.41421 12.0614 7.21597 12.1429 7.00934 12.1429C6.80271 12.1429 6.60447 12.0614 6.45801 11.915L3.45801 8.91498C3.16512 8.62208 3.16512 8.14721 3.45801 7.85431C3.75091 7.56142 4.22578 7.56142 4.51868 7.85431L7.00934 10.345L14.5393 2.81498C14.8322 2.52208 15.3071 2.52208 15.6 2.81498L15.0607 3.35431Z"
        fill="currentColor"
      />
      <path
        d="M0.939339 7.85431C1.23223 7.56142 1.7071 7.56142 2 7.85431L5 10.8543C5.29289 11.1472 5.29289 11.6221 5 11.915C4.7071 12.2079 4.23223 12.2079 3.93934 11.915L0.939339 8.91498C0.646446 8.62208 0.646446 8.14721 0.939339 7.85431Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default CheckmarkDoneFilledIcon;
